module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HowToBackground-df9fb280c1edace93cf0c41368d606d9.jpg";